import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Button from 'web/components/Button';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import { TrackDetail, TrackBox, DeliveredSection, RatingSection, ReviewSection } from './trackDetailTypeOneStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

const GiveRatingComponent = ({index, items, reviewRatingFun }) => {
    const dispatch = useDispatch();
    const [rating, setRating] = useState(0)
    const [note, setNote] = useState('')

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()

    useEffect(() => {
        if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    const setRatingFunction = async () => {
        reviewRatingFun(items, rating, note)
    }

    return (
        <>
            <TrackDetail>
                <TrackBox>
                    <DeliveredSection>
                        <RatingSection>
                            <div>Rate Order :</div>
                            <Box component="fieldset" mb={3} borderColor="transparent">
                                <Rating
                                    name={"simple-controlled" + index}
                                    value={rating}
                                    onChange={(event, newValue) => {
                                        setRating(newValue)
                                    }}
                                />
                            </Box>
                        </RatingSection>
                        <ReviewSection>
                            <p className="mt-0">{pageLanguageContents?.DetailedContents[10]?.WriteReview}</p>
                            <textarea
                                name='note'
                                maxLength='500'
                                onChange={event => {
                                    setNote(event.target.value)
                                }}
                            />
                            <Button
                                type='app-green-button'
                                handleClick={setRatingFunction}
                                disabled={note === '' && rating === 0}
                            >
                                {pageLanguageContents?.DetailedContents[11]?.Submit}
                            </Button>
                        </ReviewSection>
                    </DeliveredSection>
                </TrackBox>
            </TrackDetail>
        </>
    )
};

export default GiveRatingComponent;